import { SellingPlanPricingAdjustmentType } from 'types/SellingPlan';
import { SubscriptionContractLine } from 'types/SubscriptionContract';

export const isLineHasFlatRatePrice = (line: SubscriptionContractLine) => {
  return !!(
    line.pricing_policy?.cycle_discounts &&
    line.pricing_policy.cycle_discounts[0].adjustment_type === SellingPlanPricingAdjustmentType.PRICE
  );
};
